<template>
    <div class="configuracoes">
        
        <ContainerTitle icon="desktop" title="Administração"/>
        
        <div class="configuracoes-content pt-0 pb-3 ">
            <div class="d-flex align-items-center p-4">
                <div class="title title-primary d-flex w-50 m-0">
                    <DynamicIcon icon="color-pencil" classString="container-title-icon mr-2"/>
                    <p class="d-flex align-items-center mt-1 optum-bold font-24px">Configurações</p> 
                </div>
            </div>
        </div>

        <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(config, index) in configItens" :key="index" v-b-tooltip.hover.top="config.tooltip">
                <label>{{config.name}}</label>
                <b-form-checkbox switch size="lg" v-model="config.value" @change="setConfig( config.id, config.value )" 
                v-if="['mfa.active.token'].includes(config.id) "/>
            </b-list-group-item>
        </b-list-group>
        <ModalAlert id="modal-set-config-sucess" type="success">
            Configuração alterada com sucesso!
        </ModalAlert>
    </div>
</template>
<script>


import ContainerTitle from "@/components/commons/ContainerTitle.vue";
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import configItensFactory from "./config-itens"
import ConfigResouce from "../../../../../resources/ConfigResource"
import ModalAlert from "@/components/commons/ModalAlert"
import { mapGetters } from "vuex"

export default {
    components: {
        ContainerTitle,
		ModalAlert,
        DynamicIcon
	},
    data() {
        return {
            configItens: []
        }
    },
    computed:{
        ...mapGetters("user", ["authorities"]),
    },
    methods: {
        loadConfigs(){
            ConfigResouce.getConfigsByRole({ showLoader: true })
			.then(configs => {
                for(let config in this.configItens) {
                    let value = configs.find( item => item.key == this.configItens[config].id).value

                    this.configItens[config].value = this.configItens[config].valueConvert( value )
                }
			})
        },
        setConfig( key , value ){
            ConfigResouce.setConfig({ key: key.toString(), value: value.toString() }, { showLoader: true })
			.then(() => {
                this.$bvModal.show("modal-set-config-sucess")
			})
        },
        setConfigItensPermitidos(){
            this.authorities.forEach( authoritieUser => {
                configItensFactory.forEach(config => {
                        if(config.authorities.includes(authoritieUser) && !this.configItens.includes(config)) {
                            this.configItens.push(config)
                        }
                    })
            })
        }
    },
    created(){
        this.loadConfigs()
        this.setConfigItensPermitidos()
    }
}
</script>

<style scoped>
.configuracoes {
    padding: 0 2rem 0 2rem ;
}
.configuracoes-content {
	justify-content: space-between;
    color: #707070;
	font-size: 18px;
	text-align: left;
    background-color: #fff;
}
</style>